import { trendsIndex } from '~/search-domain/indexes';
import { buildTrendsQuery } from '~/search-domain/pipelines/trends/build-query';
import {
  getTrendsBaseFilters,
  getTrendsFacetAttributes,
  getTrendsSearchSettings,
  getTrendsSorting,
} from '~/search-domain/pipelines/trends/query-config';
import { transformTrendsResponse } from '~/search-domain/pipelines/trends/transform-response';
import { type TrendsSearchResponseBody } from '~/search-domain/pipelines/trends/types';
import { type SearchPipelineDefinition, type SearchUiState } from '~/search-domain/types';

const resolveTrendsSorting = (context: Parameters<typeof getTrendsSorting>[0]) => getTrendsSorting(context);

export const trendsPipelineDefinition: SearchPipelineDefinition<SearchUiState, TrendsSearchResponseBody> = {
  buildSearchRequest: buildTrendsQuery,
  facetAttributes: context => getTrendsFacetAttributes(context),
  getBaseFilters: context => getTrendsBaseFilters(context),
  getSearchUiConfig: context => ({
    searchAttributes: getTrendsSearchSettings(context).search ?? [],
    sorting: () => resolveTrendsSorting(context),
  }),
  getSorting: context => resolveTrendsSorting(context),
  id: trendsIndex,
  searchSettings: context => getTrendsSearchSettings(context),
  transformResponse: transformTrendsResponse,
};
